import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
/**
 * 自定义文件上传钩子函数
 * 该钩子函数用于处理文件上传过程中的相关事件和状态更新
 * @param {Object} params - 包含事件发射函数、属性、事件、模型对象等的配置对象
 * @param {Function} params.emits - 用于发射自定义事件的函数
 * @param {Object} params.props - 组件属性
 * @param {Object} params.events - 事件对象
 * @param {Object} params.pModelObj - 父组件的模型对象
 * @param {Object} params.model - 当前组件的模型
 * @returns {Object} - 返回包含处理完成文件上传逻辑的函数的对象
 */
export function useFileUploadHook({emits, props,busTempId, events,pModelObj, model}: any) {
  // 使用通用事件处理钩子函数处理点击事件
  const {clickEvent} = useComEvent({events});

  /**
   * 处理文件上传完成的逻辑
   * @param {Object} params - 包含文件列表的配置对象
   * @param {Array} params.fileList - 已上传文件的列表
   */
  const doneFile=function ({fileList}){
    let fileObj= {};
    if(fileList.length===1){
      fileObj = fileList[0]
    }

    if((unref(pModelObj)[unref(model).key]==null||unref(pModelObj)[unref(model).key]==='')&&unref(busTempId)){
      unref(pModelObj)[unref(model).key]=unref(busTempId);
    }
    // 使用调试器断点以便于调试
    // 发射'doneFile'事件并传递文件列表
    emits('doneFile',{fileList});
    // 在下一个Tick中执行回调函数，确保所有数据更新完成
    nextTick(()=>{
      clickEvent('uploadOk', {
        curObj: unref(props),
        fileObj: fileObj,
        fileName:fileObj['name'],
        formObj: unref(pModelObj)
      });
    })
  }

  // 返回包含处理完成文件上传逻辑的函数的对象
  return {
    doneFile
  }
}
